import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postForgotPassword } from '../../../api';

export const securityAuthenticationForgotPasswordAsyncSlice = createPostAsyncSlice({
	name: 'SecurityAuthenticationForgotPassword',
	receive: true,
	request: true,
	requestHandler: postForgotPassword
});
